export const IMAGES = {
  heroDawn: "https://images.pexels.com/photos/38471453/pexels-photo-38471453.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=1000",
  galleria: "https://images.pexels.com/photos/13046525/pexels-photo-13046525.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
  interiorWarm: "https://images.unsplash.com/photo-1678762200388-51e11225d4de?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  interiorLight: "https://images.unsplash.com/photo-1656122381069-9ec666d95cf1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  facade: "https://images.unsplash.com/photo-1729372462348-628ecb90c53b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
};

export const LOGO = "https://customer-assets-lqy194kg.emergentagent.net/job_alba-immobili/artifacts/1kjazhbl_logo-orizzontale-bianco.png";

export const WHATSAPP_URL = "https://wa.me/393282607116?text=Salve%2C%20vorrei%20una%20valutazione%20per%20la%20mia%20casa%20a%20Milano.";
export const MAPS_QUERY = "Via+Cenisio+40+Milano";
export const MAPS_PLACE_URL = "https://www.google.com/maps/search/?api=1&query=Alba+Immobili+Via+Cenisio+40+Milano";

export const EASE = [0.76, 0, 0.24, 1];
